export default "__VITE_ASSET__CXvEHu_B__"